import { render, staticRenderFns } from "./CreateupdateCustomer.vue?vue&type=template&id=053c3ad8&scoped=true&"
import script from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateupdateCustomer.vue?vue&type=style&index=0&id=053c3ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c3ad8",
  null
  
)

export default component.exports